import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { MetaSettings } from './meta-settings.model';

@Injectable()
export class MetaService {
    private metaSettings: Partial<MetaSettings> = {};

    public constructor(private meta: Meta, private titleService: Title) {
        this.resetMetaSettings();
    }

    public updateMetaSettings(settings: Partial<MetaSettings>): void {
        Object.assign(this.metaSettings, settings);

        this.updateAllTags('description', this.metaSettings.description);
        this.updateOGTag('image', this.metaSettings.image);
        this.updateAllTags('title', this.metaSettings.title);
        this.updateOGTag('type', this.metaSettings.type);
        this.updateOGTag('url', this.metaSettings.url);

        const pageTitle = this.metaSettings.pageTitle === null
            ? this.metaSettings.pageTitleSuffix
            : [
                this.metaSettings.pageTitle,
                this.metaSettings.pageTitleSeparator,
                this.metaSettings.pageTitleSuffix,
            ].join('');
        this.titleService.setTitle(pageTitle);
    }

    public resetMetaSettings(): void {
        this.updateMetaSettings({
            description: '',
            pageTitle: null,
            pageTitleSeparator: ' | ',
            pageTitleSuffix: 'Mercit',
            title: 'Mercit',
            type: 'website',
            url: null,
        });
    }

    private updateAllTags(key: string, value: string): void {
        this.updateOGTag(key, value);
        this.updateTag(key, value);
    }

    private updateOGTag(key: string, value: string): void {
        if (!value) {
            this.meta.removeTag(`property='og:${key}'`);
        } else {
            this.meta.updateTag({
                content: value,
                property:  'og:' + key,
            });
        }
    }

    private updateTag(key: string, value: string): void {
        if (!value) {
            this.meta.removeTag(`name='${key}'`);
        } else {
            this.meta.updateTag({
                content: value,
                name: key,
            });
        }
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/meta.service.ts